export default class LetterNav {
    constructor() {
        this.element = document.querySelector('[data-letter-nav]');
        this.navItemSelector = '[data-navitem]';
        this.dataNavItem = 'data-navitem';
        this.positionWaypoint = '[data-position-waypoint]';
        this.letterNavModifier = 'letter-nav--fixed';
        this.activeClass = 'active';
        this.init();
    }

    init() {
        if (typeof IntersectionObserver === typeof undefined) {
            return false;
        }
        // early exit
        if (this.element === null) {
            return false;
        }

        const navItems = this.getNavItems(this.element);
        const thresholdElement = this.getThresholdElement();

        navItems.forEach((navItem) => {
            navItem.addEventListener('click', () => {
                this.updateActiveNavItem(
                    navItem,
                    document.getElementById(navItem.getAttribute(this.dataNavItem)),
                    document.querySelector(`.${this.activeClass}${this.navItemSelector}`)
                );
            });
        });

        if (thresholdElement !== null) {
            const letterNavObserver = new IntersectionObserver(([entry]) => {
                this.element.classList.toggle(this.letterNavModifier, !entry.isIntersecting);
            });
            letterNavObserver.observe(thresholdElement);
        }
    }

    getNavItems(letterNav) {
        return letterNav.querySelectorAll(this.navItemSelector);
    }

    getThresholdElement() {
        return document.querySelector(this.positionWaypoint);
    }

    updateActiveNavItem(navItem, scrollTarget, activeItem) {
        navItem.classList.add(this.activeClass);

        if (scrollTarget !== null) {
            this.scrollToLexikonTarget(scrollTarget);
        }
        if (activeItem !== null) {
            activeItem.classList.remove(this.activeClass);
        }
    }

    scrollToLexikonTarget(scrollTarget) {
        scrollTarget.scrollIntoView({
            behavior: 'smooth'
        });
    }
}
